import { SettingsService } from '../settings/settings.service';
import { filter, map, Subject, Subscription, takeUntil, tap } from 'rxjs';
import {
    Component,
    OnDestroy,
    OnInit,
    ViewContainerRef,
    inject,
    output,
    viewChild,
    computed,
} from '@angular/core';
import { ActivatedRoute, EventType, Router, RouterLink } from '@angular/router';
import { LogoutService } from '../logout/logout.service';
import { JwtUtilService } from '../core/jwt-util.service';
import { UrlUtils } from '../shared/utils/url.utils';
import { DiscoveryService } from '../discovery/discovery.service';
import { RouterService } from '../core/router.service';
import { ResearcherDataService } from '../core/researcher-data.service';
import { CustomizationService } from '../core/customization.service';
import { I18nService } from '../core/i18n.service';
import { ConfigurationHandlerService } from '../core/configuration-handler.service';
import { MappingTable } from '../shared/interfaces/mapping-table.interface';
import { LanguageService } from '../parts/language/language.service';
import { AuthorizationService } from '../core/authorization.service';
import { MediaService, MediaIfDirective } from '@exl-ng/mulo-core';
import {
    GrowInAnimation,
    GrowOutAnimation,
    MatCssAdditionalPaletteContrastNames,
    SearchbarComponent,
    SideNavService,
    SlideInAnimation,
    SlideOutAnimation,
    HeaderComponent,
    HeaderNavItemComponent,
    BrandComponent,
    SearchbarOptionsComponent,
    HeaderLinksComponent,
    HeaderNavComponent,
    FunkyButtonComponent,
    LanguageSelectButtonComponent,
    NotifyBellComponent,
    MenuToggleButtonComponent,
} from '@exl-ng/mulo-common';
// eslint-disable-next-line max-len
import { PortalEsploroHeaderLinksConfiguration } from '../shared/interfaces/view-configuration/portal-esploro-links-configuration.interface';
import { LinkResolverService } from '../core/link-resolver.service';
import { BrandService } from '../core/brand.service';
import { Discovery } from '../shared/configurations/discovery.constant';
import { MatExpansionPanel, MatAccordion } from '@angular/material/expansion';
import { EsploroEntity } from '../shared/interfaces/esploro-entity';
import { DepositFormTriggerDirective } from '../deposit/deposit-form-trigger.directive';
import { AddProjectComponent } from '../project/add-project/add-project.component';
import { ContentDialogService } from '../parts/dialogs/content-dialog/content-dialog.service';
import { PivotService } from '../pivot-standalone/pivot.service';
import { SearchEntities } from '../shared/configurations/portal-search.constant';
import { PortalService } from '../portal/portal.service';
import { CustomerParameters } from '../shared/configurations/customer-parameters.constant';
import { AddActivitiesComponent } from '../activities/add-activities/add-activities.component';
import { SessionStorageUtilService } from '../core/session-storage-util.service';
import { ClaimOutputsService } from '../profile/claim-outputs/claim-outputs.service';
import { EntitySearchService } from '../discovery/entity-search.service';
import { State } from '../shared/configurations/state.constant';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordDialogComponent } from '../parts/dialogs/change-password-dialog/change-password-dialog.component';
import { MatButton, MatAnchor, MatIconButton } from '@angular/material/button';
import { ProfileService } from '../profile/profile.service';
import { MomentModule } from 'ngx-moment';
import { TranslateModule } from '@ngx-translate/core';
import { MatDivider } from '@angular/material/divider';
import { MatNavList, MatListItem } from '@angular/material/list';
import { AdvancedSearchComponent } from '../parts/advanced-search/advanced-search.component';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { UserMenuComponent } from '../parts/user-menu/user-menu.component';
import { UserNavComponent } from '../parts/user-nav/user-nav.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { AsyncPipe, SlicePipe } from '@angular/common';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { DepositOutputDialogComponent } from '../deposit/deposit-output-dialog/deposit-output-dialog.component';
import { NotificationsService } from '../notifications/notifications.service';
import { NotificationsMenuComponent } from '../notifications/notifications-menu/notifications-menu.component';
import { RequestsService } from '../profile/requests/requests.service';
import {AuthService} from "../core/auth.service";

@Component({
    selector: 'esp-esploro-header',
    templateUrl: './esploro-header.component.html',
    styleUrls: ['./esploro-header.component.scss'],
    animations: [
        SlideInAnimation,
        SlideOutAnimation,
        GrowInAnimation,
        GrowOutAnimation,
    ],
    imports: [
        HeaderComponent,
        CdkOverlayOrigin,
        HeaderNavItemComponent,
        BrandComponent,
        MatButton,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        MatMenuItem,
        RouterLink,
        MatTooltip,
        SearchbarComponent,
        SearchbarOptionsComponent,
        MediaIfDirective,
        HeaderLinksComponent,
        MatAnchor,
        MatIconButton,
        HeaderNavComponent,
        FunkyButtonComponent,
        DepositFormTriggerDirective,
        LanguageSelectButtonComponent,
        UserNavComponent,
        UserMenuComponent,
        MenuToggleButtonComponent,
        CdkConnectedOverlay,
        MatAccordion,
        CdkTrapFocus,
        MatExpansionPanel,
        AdvancedSearchComponent,
        MatNavList,
        MatListItem,
        MatDivider,
        AsyncPipe,
        SlicePipe,
        TranslateModule,
        MomentModule,
        NotificationsMenuComponent,
    ],
})
export class EsploroHeaderComponent implements OnInit, OnDestroy {
    private logoutService = inject(LogoutService);
    private jwtUtilService = inject(JwtUtilService);
    private router = inject(Router);
    private settingsService = inject(SettingsService);
    discoveryService = inject(DiscoveryService);
    private researcherDataService = inject(ResearcherDataService);
    private profileSvc = inject(ProfileService);
    private customizationService = inject(CustomizationService);
    private i18nService = inject(I18nService);
    private configSvc = inject(ConfigurationHandlerService);
    private languageService = inject(LanguageService);
    private authorizationService = inject(AuthorizationService);
    media = inject(MediaService);
    private sidenavService = inject(SideNavService);
    private linkResolverService = inject(LinkResolverService);
    private brandService = inject(BrandService);
    private pivotService = inject(PivotService);
    private contentDialogService = inject(ContentDialogService);
    private portalService = inject(PortalService);
    private sessionStorageUtilService = inject(SessionStorageUtilService);
    private claimOutputsService = inject(ClaimOutputsService);
    private requestsSvc = inject(RequestsService);
    private entitySearchService = inject(EntitySearchService);
    private dialog = inject(MatDialog);
    private notifySvc = inject(NotificationsService);
    private authSvc = inject(AuthService);

    readonly toggleNotifications = output<any>();
    readonly showFunding = output<any>();

    readonly sidenavOpen = computed(() => this.sidenavService.isOpen());

    menuItems;
    notifications;
    institutionCode: string;
    institutionName: string;
    imgSubscription: Subscription;
    userAvatarImage;

    proxyName;
    proxyAvatarImage;

    showOnboarding = false;
    modeTheme: 'light' | 'dark';

    userInitials: string;
    proxyInitials: string;
    languages;
    searchQuery = '';
    logoUrl$;
    searchEntities = [];
    searchScopesByEntity = [];
    activeScope: string;
    selectedScope: string;

    activeEntity = 'outputs';
    selectedEntity: string;
    autocompleteSearchBy = [];
    entities = [];
    headerLinks: PortalEsploroHeaderLinksConfiguration[];
    headerLinksFiltered: PortalEsploroHeaderLinksConfiguration[];
    includeSignIn: boolean;
    includePivot: boolean;
    searchbarPlaceholder = 'research.header.search.placeholder';

    displaySearchBar = true;

    contentEntities: EsploroEntity[] = [];

    advancedSearchEnabled = false;

    notifyCount = computed(() => this.notifySvc.totalCount());

    readonly headerMenu = viewChild<ViewContainerRef>('headerMenu');
    readonly searchbarMobile = viewChild<SearchbarComponent>('mobileSearchbar');
    readonly depositDirective = viewChild(DepositFormTriggerDirective);
    readonly mobileSearchMenu =
        viewChild<MatExpansionPanel>('mobileSearchMenu');
    readonly mobileSearchBtn = viewChild<MatButton>('mobileSearchBtn');
    readonly advSearchBlock = viewChild<ViewContainerRef>('advSearchBlock');

    displayEntityMenu = false;
    searchbarState;
    itemsInMenu;
    minuteInMilliseconds = 60000;
    timerPeriod = this.minuteInMilliseconds * 60 * 3;

    componentDestroy = new Subject<void>();
    mobileSearchMenuOpen = false;
    constructor() {
        const jwtUtilService = this.jwtUtilService;
        const configSvc = this.configSvc;
        const portalService = this.portalService;

        this.institutionCode = UrlUtils.getParam('institution');
        this.institutionName = configSvc.mainInstitutionName();
        this.includeSignIn = configSvc.portalConfigurationHedearIncludeSignIn();
        if (
            configSvc.portalConfigurationHedearIncludePivot() &&
            jwtUtilService.isResearcherTypeLoggedIn()
        ) {
            this.pivotService
                .getHasPivot(this.jwtUtilService.getUserID())
                .subscribe((hasPivot) => {
                    this.includePivot = hasPivot;
                });
        }
        portalService.openMobileAdvSearch.subscribe(() =>
            this.toggleAdvSearchSidenav(),
        );
    }

    ngOnInit() {
        this.imgSubscription = this.researcherDataService.imageUrl$.subscribe(
            (res) => {
                this.userAvatarImage = res;
            },
        );
        if (this.isResearcherLoggedIn()) {
            this.loadProfileImage();
        }
        if (this.jwtUtilService.getCurrentUserForProxy()) {
            this.setProxyData();
        }
        this.searchEntities = this.entitySearchService.getSearchEntities();
        if (this.searchEntities.length >= 1) {
            this.setCurrentEntity(this.searchEntities[0].value);
        }
        this.languages = this.getLanguageMenuOptions();
        this.userInitials = this.getInitials();
        this.setMenuItems();
        this.handleOnboarding();
        this.setLogoTheme();
        this.displayEntityMenu =
            this.configSvc.isCustomerParameterEnabled(
                'esploro_new_homepage_and_header',
            ) && this.configSvc.portalConfigurationHedearIncludeDropdownMenu();
        this.handleHeaderLinks();
        this.logoUrl$ = this.brandService.logoPathUrl$;
        this.entities = this.configSvc.activeEntities();
        this.setContentMenuEntities();
        if (this.isResearcherLoggedIn()) {
            this.handleNotifications();
        }
    }

    handleNotifications() {
        this.claimOutputsService.updateData();
        this.requestsSvc.updateData();
    }

    get userName() {
        return this.jwtUtilService.getUserDisplayName();
    }

    get selectedLanguage() {
        return this.i18nService.getLanguage();
    }

    getLanguageMenuOptions() {
        const institutionLanguagesMT = this.configSvc.getMappingTable(
            'esploro_InstitutionLanguages',
        ) as MappingTable[];
        return institutionLanguagesMT
            .filter((row) => row.source2 === 'true' && row.enabled === 'true')
            .map((row) => {
                return row.target;
            });
    }

    getInitials(forceJwt = false) {
        let initials = this.jwtUtilService
            .getLastName(forceJwt)
            .charAt(0)
            .toUpperCase();
        if (this.jwtUtilService.getFirstName(forceJwt)) {
            initials =
                this.jwtUtilService
                    .getFirstName(forceJwt)
                    .charAt(0)
                    .toUpperCase() + initials;
        }
        return initials;
    }

    setProxyData() {
        this.proxyName = this.jwtUtilService.getUserDisplayName(true);
        this.proxyInitials = this.getInitials(true);
        this.settingsService
            .getResearcherProfileImage(this.jwtUtilService.getUserID(true))
            .subscribe((data) => {
                if (data) {
                    this.proxyAvatarImage = window.URL.createObjectURL(data);
                }
            });
    }

    handleOnboarding() {
        if (this.jwtUtilService.getCurrentUserForProxy()) {
            setTimeout(() => {
                this.showOnboarding = true;
            }, 0);
        }
    }

    handleHeaderLinks() {
        const links = this.configSvc.portalConfigurationHeaderLinks() || [];
        links.forEach((item) => {
            item.url = this.linkResolverService.getLinkUrl(item.url);
        });
        this.headerLinks = links.filter((item) => item.active);
        this.headerLinksFiltered = this.displayEntityMenu
            ? this.headerLinks.filter((link) => link.display)
            : this.headerLinks;
    }

    setMenuItems() {
        this.menuItems = [
            {
                section: 'links',
                divider:
                    !this.configSvc.getFeatureFlagEnabled('ENABLE_ONETRUST'),
                items: [
                    {
                        label: 'research.header.profile',
                        link: '/profile',
                        disabled: false,
                    },
                    {
                        label: 'research.header.settings',
                        link: '/settings',
                        disabled: false,
                    },
                ],
            },
        ];
        if (this.configSvc.getFeatureFlagEnabled('ENABLE_ONETRUST')) {
            this.menuItems.push({
                section: 'onetrust',
                divider: true,
                items: [
                    {
                        labelMethod: () =>
                            document.getElementById('ot-sdk-btn').innerText,
                        action: 'onetrust',
                    },
                ],
            });
        }

        if (this.jwtUtilService.getProxyFor()) {
            this.menuItems.push({
                section: 'account',
                divider: false,
                items: [
                    {
                        label: 'research.header.switch.account',
                        link: '/login-as',
                        disabled: false,
                    },
                ],
            });
        }

        if (
            !this.configSvc.isExternalLogin() &&
            this.configSvc.getCustomerParameter(
                'primo_patron_info_updatable',
            ) === 'Y'
        ) {
            this.menuItems.push({
                section: 'password',
                divider: true,
                items: [
                    {
                        label: 'research.header.change.password',
                        action: 'password',
                    },
                ],
            });
        }
    }

    loadProfileImage() {
        const userId = this.jwtUtilService.getUserID();
        this.settingsService
            .getResearcherProfileImage(userId)
            .subscribe((imgBlob) => {
                if (imgBlob) {
                    this.researcherDataService.setProfileImageUrl(imgBlob);
                } else {
                    this.profileSvc
                        .getResearcherDataForSEO(userId)
                        .subscribe((data) => {
                            this.researcherDataService.setProfileImageUrl(
                                data.researcherImageUrl ?? '',
                            );
                        });
                }
            });
    }

    isLoggedIn() {
        return this.jwtUtilService.isLoggedIn();
    }

    isResearcherLoggedIn() {
        return this.jwtUtilService.isResearcherTypeLoggedIn();
    }

    isUserLoggedIn() {
        return this.jwtUtilService.isUserTypeLoggedIn();
    }

    isResearcherDepositsEnabled() {
        return this.authorizationService.isAuthorizedForDeposit();
    }

    setLogoTheme() {
        const contrast = this.customizationService.getThemeByConfig('header');
        this.modeTheme =
            contrast === MatCssAdditionalPaletteContrastNames.dark
                ? 'light'
                : 'dark';
    }

    doSignOut() {
        this.logoutService.logout();
    }

    search(event) {
        const searchTerm = event.query || this.searchQuery;

        if (!searchTerm) {
            const mobileSearchMenu = this.mobileSearchMenu();
            if (mobileSearchMenu) {
                mobileSearchMenu.close();
            }
            return;
        }
        if (this.activeEntity === SearchEntities.RESEARCHERS_ENTITY) {
            this.goToSearchProfiles(searchTerm, this.selectedScope);
        } else if (this.activeEntity === SearchEntities.OUTPUTS_ENTITY) {
            this.goToSearchAssets(searchTerm, this.selectedScope);
        } else if (this.activeEntity === SearchEntities.PROJECTS_ENTITY) {
            this.goToSearchProjects(searchTerm, this.selectedScope);
        }

        setTimeout(() => {
            this.searchQuery = '';
            const mobileSearchMenu = this.mobileSearchMenu();
            if (mobileSearchMenu) {
                mobileSearchMenu.close();
            }
        }, 0);
    }

    handleMobileSearchBtnClick(event) {
        this.mobileSearchMenuOpen = true;
        // this.mobileSearchMenu.open();
        // this.mobileSearchMenu.afterExpand.pipe(take(1)).subscribe(() => {
        //     // this.mobileSearchMenu._body.nativeElement.tabIndex = 0;
        //     // this.mobileSearchMenu._body.nativeElement.focus();
        //     // this.mobileSearchMenu._body.nativeElement.tabIndex = -1;
        // });

        // setTimeout(() => {
        //     this.searchbarMobile.focusInput();
        // }, 100);
    }

    goToSearchProfiles(query: string, scope = 'all') {
        this.router.navigate(['/search/researchers'], {
            queryParams: {
                query,
                page: 1,
                scope,
                institution: this.institutionCode,
            },
        });
    }

    goToSearchProjects(query: string, scope) {
        this.router.navigate([State.PROJECTS_SEARCH], {
            queryParams: {
                query,
                page: 1,
                scope,
                institution: this.institutionCode,
            },
        });
    }

    goToSearchAssets(query: string, scope: string) {
        if (
            this.configSvc.getCustomerParameter(
                'esploro_new_search_results_page',
            ) !== 'true'
        ) {
            const discoveryURL = this.discoveryService.getDiscoverySearchURL(
                this.institutionCode,
                query,
            );
            window.open(discoveryURL, '_blank');
        } else {
            this.router.navigate(['/search/outputs'], {
                queryParams: {
                    query: Discovery.SIMPLE_SEARCH_QUERY_PREFIX + query,
                    scope,
                    page: 1,
                    institution: this.institutionCode,
                },
            });
        }
    }

    onUserMenuAction(action) {
        switch (action) {
            case 'language':
                this.showLanguageDialog();
                break;
            case 'password':
                this.showChangePasswordDialog();
                break;
            case 'onetrust':
                document.getElementById('ot-sdk-btn').click();
                break;
            default:
                console.info('Unhandled menu action:', action);
                break;
        }
    }

    displayLanguageButton() {
        if (this.languages && this.languages.length > 1) {
            return true;
        }
        return false;
    }

    toggleSidenav() {
        this.sidenavService.toggle('main', this.headerMenu(), {
            position: 'end',
        });
    }

    toggleAdvSearchSidenav() {
        this.mobileSearchMenuOpen = false;
        this.sidenavService.toggle('secondary', this.advSearchBlock(), {
            position: 'end',
        });
    }

    showLanguageDialog() {
        const data = {
            languages: this.languages,
            selectedLanguage: this.selectedLanguage,
        };
        this.languageService.showLanguageDialog(data);
    }

    showChangePasswordDialog() {
        this.dialog.open(ChangePasswordDialogComponent);
    }

    setContentMenuEntities() {
        const contentDataTemp: EsploroEntity[] = [
            { code: 'output', active: this.showAddAssets() },
            {
                code: 'project',
                active: this.showAddProjects(),
            },
            {
                code: 'activity',
                active: this.showAddActivities(),
            },
        ];
        this.contentEntities = contentDataTemp.filter((item) => item.active);
    }

    showAddAssets() {
        return (
            this.isResearcherDepositsEnabled() &&
            this.configSvc.configurationByDefualtView().headerFooter?.addAssets
        );
    }

    showAddProjects() {
        return this.configSvc.canEditEntityByConfig(
            CustomerParameters.ESPLORO_PROJECTS,
            'addProjects',
        );
    }

    showAddActivities() {
        return this.configSvc.canEditEntityByConfig(
            CustomerParameters.ESPLORO_ACTIVITIES,
            'addActivities',
        );
    }

    openNewDepositDialog() {
        this.contentDialogService.openDialog(
            DepositOutputDialogComponent,
            'research.output.list.add.deposit',
        );
    }

    menuContentOnClick(item: EsploroEntity) {
        switch (item.code) {
            case 'output':
                if (
                    this.configSvc.isCustomerParameterEnabled(
                        'esploro_deposit_profiles_conf',
                    )
                ) {
                    if (this.router.url.startsWith('/deposit/output')) {
                        this.router
                            .navigate(['/deposit/form'], {
                                skipLocationChange: true,
                                queryParamsHandling: 'preserve',
                            })
                            .then((res) => {
                                if (res) {
                                    this.openNewDepositDialog();
                                }
                            });
                    } else {
                        this.openNewDepositDialog();
                    }
                } else {
                    this.depositDirective().launchDepositForm();
                }
                break;
            case 'project':
                this.contentDialogService.openDialog(
                    AddProjectComponent,
                    'research.add.project.title',
                );
                break;
            case 'activity':
                this.contentDialogService.openDialog(
                    AddActivitiesComponent,
                    'research.add.activity.title',
                );
                break;
        }
    }

    ngOnDestroy() {
        if (this.imgSubscription) {
            this.imgSubscription.unsubscribe();
        }
        this.componentDestroy.next();
        this.componentDestroy.complete();
    }

    handleEntityChange(entity) {
        this.activeEntity = entity;
        this.advancedSearchEnabled =
            entity === 'outputs' &&
            this.configSvc.advancedSearchConfiguration().enableAdvancedSearch;
        this.setSearchScopesByEntity(entity);
        this.setSearchbarPlaceholder(entity);
        this.setAutocompleteSearchBy(entity);
    }

    setAutocompleteSearchBy(scope: string) {
        this.autocompleteSearchBy = this.searchEntities.find(
            (s) => s.value === scope,
        )?.searchBy;
    }

    setSearchbarPlaceholder(scope: string) {
        this.searchbarPlaceholder = this.searchEntities.find(
            (s) => s.value === scope,
        )?.placeholder;
    }

    setSearchScopesByEntity(entity: string) {
        this.searchScopesByEntity = this.searchEntities.filter(
            (s) => s.value === entity,
        )[0].scopes;
        if (this.searchScopesByEntity.length > 0) {
            this.setCurrentScope(this.searchScopesByEntity[0].value);
        }
    }

    setCurrentScope(scope) {
        this.activeScope = scope;
        this.selectedScope = scope;
    }

    handleScopeChange(scope) {
        this.selectedScope = scope;
    }

    setCurrentEntity(entity) {
        this.activeEntity = entity;
        this.selectedEntity = entity;
        this.advancedSearchEnabled =
            entity === 'outputs' &&
            this.configSvc.advancedSearchConfiguration().enableAdvancedSearch;
        this.setSearchbarPlaceholder(entity);
        this.setSearchScopesByEntity(entity);
    }

    getEntityParams(entity) {
        const qParams = {
            ...(entity.qParams || {}),
            institution: this.institutionCode,
        };

        return qParams;
    }

    runAdvancedSearch(params) {
        const mobileSearchMenu = this.mobileSearchMenu();
        if (mobileSearchMenu) {
            mobileSearchMenu.close();
        }

        this.router.navigate(['/search/outputs'], {
            queryParams: {
                query: params.query,
                scope: params.scope,
                pfilter: params.pfilter,
                mode: 'advanced',
                page: 1,
                institution: this.institutionCode,
            },
        });
    }

    handleLanguageChange(language) {
        this.i18nService.setLanguage(language);
        if (this.jwtUtilService.isResearcherTypeLoggedInNonAdmin()) {
            const langJson = { language };
            this.languageService
                .changeUserLanguage(langJson)
                .subscribe((data) => {
                    this.authSvc.handleResearcherLogin(data);
                });
        } else {
            this.sessionStorageUtilService.setSessionLanguage(language);
        }
        setTimeout(() => {
            this.languageService.closeDialog();
        }, 500);
    }

    handleMobileSearchBtnClose() {
        this.mobileSearchMenuOpen = false;
        // this.mobileSearchMenu.close();
        setTimeout(() => this.mobileSearchBtn().focus());
    }
}
